import DataService from '@/services/DataService';

const initialState = {
	dataAvailable: [],
	dataElements: [],
	dataElementState: null,
	dataRedirectTo: null
};

export default {
	namespaced: true,

	//#region [ State ]
	state: {
		...initialState
	},
	//#endregion

	//#region [ Mutations ]
	mutations: {
		setDataAvailable(state, payload) {
			state.dataAvailable = payload;
		},

		setDataElements(state, payload) {
			state.dataElements = payload;
		},

		setDataElement(state, payload) {
			state.dataElementState = payload;
		},

		reset(state) {
			Object.assign(state, initialState);
		},

		setRedirectTo(state, payload) {
			state.dataRedirectTo = payload;
		}
	},
	//#endregion

	//#region [ Actions ]
	actions: {
		async getDataElements({ commit }) {
			try {
				const res = await DataService.getAll();
				if (res.Code === 200) {
					commit('setDataElements', res.Data);
				}
				return res;
			} catch (error) {
				console.log(error);
			}
		},

		async getDataAvailable({ commit }, payload) {
			try {
				let res = null;
				if (payload.type == 'family') {
					res = await DataService.getFamilyUnsignedData(payload.id);
				} else {
					res = await DataService.getChildAvailablesData(payload.id);
				}
				if (res && res.Code === 200) {
					commit('setDataAvailable', res.Data);
				}
				return res;
			} catch (error) {
				console.log(error);
			}
		},

		async getDataById({ commit }, id) {
			try {
				const res = await DataService.getDataById(id);
				if (res.Code === 200) {
					commit('setDataElement', res.Data);
				}
				return res;
			} catch (error) {
				console.log(error);
			}
		},

		resetDataStoreState({ commit }) {
			commit('reset');
		},

		setDataRedirect({ commit }, value) {
			commit('setRedirectTo', value);
		},

		setDataElementState({ commit }, value) {
			commit('setDataElement', value);
		},

		// eslint-disable-next-line no-unused-vars
		async saveDataElement({ commit }, dataElement) {
			try {
				return await DataService.saveDataElement(dataElement);
			} catch (error) {
				console.log(error);
			}
		},

		// eslint-disable-next-line no-unused-vars
		async updateDataElement({ commit }, dataElement) {
			try {
				return await DataService.updateDataElement(dataElement);
			} catch (error) {
				console.log(error);
			}
		}
	},
	//#endregion

	//#region [ Getters ]
	getters: {}
	//#endregion
};
